var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccepted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.646,
    height: 19.752,
    viewBox: "0 0 24.646 19.752",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_693",
    "data-name": "Caminho 693",
    d: "M-6331.142-3144.69l5.6,5.6,17.631-17.631",
    transform: "translate(6331.849 3157.427)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccepted);
export default __webpack_public_path__ + "static/media/accepted.0b4e5de93b26abd74d8ffb5638e3b3e8.svg";
export { ForwardRef as ReactComponent };